module.exports = __webpack_public_path__ + "6bd3-two.png";